module.exports = [
    {
        "_id": "b3f69d8433c970bb",
        "name": "Crafts Workshop",
        "experiencePoints": 1000,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "nfgaqtX8mDQBxdR1",
        "name": "Kitchen",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Kitchen.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Kitchen.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Kitchen.B2",
                "type": "WALL"
            }
        ],
        "skillName": "RizBDBH25GAPJAh4",
        "experiencePoints": 1000
    },
    {
        "_id": "mj6bKAWebFNsUEE3",
        "name": "Woodcollier's",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Colliers.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Colliers.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Colliers.B2",
                "type": "WALL"
            }
        ],
        "skillName": "Jo5ymhHA93tLAAjH",
        "experiencePoints": 1000,
        "craftingCost": 50
    },
    {
        "_id": "cb8014e5f456106b",
        "name": "Casing 1 - Water Bath",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "SZb2IdoH0zgnu2Sa",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Casing1.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Casing1.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Casing1.B2",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "WALL"
            }
        ]
    },
    {
        "_id": "hrRd1qUfeAGvi4Hz",
        "name": "Dyer's",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Dyers.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Dyers.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "Dyers.C3",
                "type": "WALL"
            }
        ],
        "skillName": "220EQ0JxY0dabZZr",
        "experiencePoints": 1000
    },
    {
        "_id": "06b4a573bfe98a7c",
        "name": "Casing 2 - Stretching Frames",
        "experiencePoints": 1000,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Casing2.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Casing2.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Casing2.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "rotDays": 0
    },
    {
        "_id": "u9nfqrbEczbiGf0m",
        "name": "Jeweller's",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Jewellers.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Jewellers.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Jewellers.B2",
                "type": "WALL"
            }
        ],
        "skillName": "xmZmY9MEIX6Z6hN1",
        "experiencePoints": 1000
    },
    {
        "_id": "ytOQk7QAsuTzGnHm",
        "name": "Blacksmith's",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "xvLTnQzjIhcEIufd",
        "experiencePoints": 1000
    },
    {
        "_id": "6b4a573bfe98a7c4",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Casing3.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Casing3.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Casing3.B2",
                "type": "WALL"
            }
        ],
        "name": "Casing 3 - Oil Vat",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "HLWBAd84MOtvIn3a",
        "name": "Builder's Yard",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Builders.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Builders.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Builders.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Builders.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "Builders.C3",
                "type": "WALL"
            }
        ],
        "skillName": "d9sUDmCVjbpZaL8P",
        "experiencePoints": 1000
    },
    {
        "_id": "W4lEADBS86qwMWOI",
        "name": "Apothecary",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Apothecary.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Apothecary.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Apothecary.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "experiencePoints": 1000
    },
    {
        "_id": "INbqncOphA3Ehzr5",
        "name": "Potter's",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Potters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Potters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Potters.B1",
                "type": "WALL"
            }
        ],
        "skillName": "kISpJFjjw10SxDhb",
        "experiencePoints": 1000
    },
    {
        "_id": "bfe98a7c4d97a3f2",
        "name": "Switch 3 - Box Form",
        "experiencePoints": 1000,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "573bfe98a7c4d97a",
        "name": "Casing 7 - Hardening Table",
        "experiencePoints": 1000,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Casing7.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Casing7.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Casing7.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "rotDays": 0
    },
    {
        "_id": "e98a7c4d97a3f2b1",
        "name": "Switch 5 - Rubbing Stone",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "a573bfe98a7c4d97",
        "name": "Casing 6 - Adhesive Table",
        "experiencePoints": 1000,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Casing6.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Casing6.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Casing6.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "v7zHmO85Gi3d5xbR",
        "craftingCost": 50,
        "name": "Clothing - Primitive Tailor's",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2",
        "experiencePoints": 1000
    },
    {
        "_id": "g2kN1zSxh0KKyQ5Z",
        "name": "Doctor's",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Doctors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Doctors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Doctors.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Doctors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "Doctors.C3",
                "type": "WALL"
            }
        ],
        "skillName": "LnmHXTey16zJ9Gtb",
        "experiencePoints": 1000
    },
    {
        "_id": "3bfe98a7c4d97a3f",
        "name": "Switch 2 - Nozzle Form",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "SZb2IdoH0zgnu2Sa",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ]
    },
    {
        "_id": "4a573bfe98a7c4d9",
        "name": "Casing 5 - Moulding Room",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Casing5.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Casing5.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Casing5.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "fe98a7c4d97a3f2b",
        "name": "Switch 4 - Felting Brushes",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "a7c4d97a3f2b1b20",
        "name": "Hinge 2 - Bark Press",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Hinge2.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Hinge2.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Hinge2.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "73bfe98a7c4d97a3",
        "name": "Switch 1 - Root Thresher",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "zpgsOo79SjDztplE",
        "name": "Carpenter's",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "experiencePoints": 1000,
        "craftingCost": 50
    },
    {
        "_id": "8a7c4d97a3f2b1b2",
        "name": "Hinge 1 - Bark Stripping Boards",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Hinge1.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Hinge1.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Hinge1.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "X6UmhB1vIkNxJJS8",
        "name": "Leather 2 - Tannery",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tanners.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Tanners.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Tanners.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "dhXOdHB7LqNBuHRV",
        "experiencePoints": 1000
    },
    {
        "_id": "8Yi0WXgERJxYdz24",
        "name": "Stonemason's",
        "rotDays": 0,
        "craftingTools":
        [],
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Masons.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Masons.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Masons.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Masons.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "Masons.C3",
                "type": "WALL"
            }
        ],
        "skillName": "KcRCN5B875wl6TW6",
        "experiencePoints": 1000
    },
    {
        "_id": "7c4d97a3f2b1b20c",
        "name": "Hinge 3 - Bark Roller",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Hinge3.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Hinge3.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Hinge3.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "97a3f2b1b20c6cb1",
        "name": "Hinge 5 - Shrinking Whackers",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Hinge5.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Hinge5.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Hinge5.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "c6cb15789b675cf9",
        "name": "Cog 1 - Cogwood Smoker",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Cog1.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Cog1.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Cog1.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "98a7c4d97a3f2b1b",
        "name": "Switch 6 - Switch Shop",
        "experiencePoints": 1000,
        "skillName": "SZb2IdoH0zgnu2Sa",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "rotDays": 0
    },
    {
        "_id": "6cb15789b675cf97",
        "name": "Cog 2 - Cogwood Press",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Cog2.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Cog2.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Cog2.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "experiencePoints": 1000,
        "rotDays": 0
    },
    {
        "_id": "9b675cf9768a14e1",
        "name": "Wires 2 - Threshing Floor",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Wire2.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Wire2.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Wire2.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "experiencePoints": 1000,
        "rotDays": 0
    },
    {
        "_id": "89b675cf9768a14e",
        "name": "Wires 1 - Steam Chamber",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Wire1.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Wire1.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Wire1.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "0c6cb15789b675cf",
        "name": "Shaft 4 - Carpeted Barrel",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "SZb2IdoH0zgnu2Sa",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ]
    },
    {
        "_id": "c4d97a3f2b1b20c6",
        "name": "Hinge 4 - Hinge Shop",
        "experiencePoints": 1000,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Hinge4.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Hinge4.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Hinge4.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "rotDays": 0
    },
    {
        "_id": "cb15789b675cf976",
        "name": "Cog 3 - Cog Shop",
        "experiencePoints": 1000,
        "skillName": "SZb2IdoH0zgnu2Sa",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Cog3.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Cog3.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Cog3.B2",
                "type": "WALL"
            }
        ],
        "rotDays": 0
    },
    {
        "_id": "b15789b675cf9768",
        "name": "Wood 1 - Wood Mill",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Wood1.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Wood1.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Wood1.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "craftingCost": 50
    },
    {
        "_id": "b675cf9768a14e1e",
        "name": "Wires 3 - Wire Spindle",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Wire3.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Wire3.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Wire3.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "675cf9768a14e1ec",
        "name": "Spring 1 - Pulping Bucket",
        "experiencePoints": 1000,
        "weight": null,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Spring1.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Spring1.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Spring1.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "15789b675cf9768a",
        "craftingCost": 50,
        "name": "Wood 2 - Wood Shop",
        "experiencePoints": 1000,
        "weight": null,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Wood2.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Wood2.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Wood2.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "14e1ecd555b03bc3",
        "name": "Rubber 3 - Airation Nets",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "cd555b03bc3d2de4",
        "name": "Clock 3 - Clockmakers Table",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "1ecd555b03bc3d2d",
        "name": "Clock 1 - Clockmakers Block",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "4e1ecd555b03bc3d",
        "name": "Rubber 4 - Stretching prongs",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "ecd555b03bc3d2de",
        "name": "Clock 2 - Twisting Boards",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "5b03bc3d2de4a314",
        "name": "Clock 7 - Clockmakers Shop",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "75cf9768a14e1ecd",
        "name": "Spring 2 - Springfleshery",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Spring2.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Spring2.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Spring2.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "a14e1ecd555b03bc",
        "name": "Rubber 2 - Seiving Floor",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "d555b03bc3d2de4a",
        "name": "Clock 4 - Oscillation Loom",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "cf9768a14e1ecd55",
        "name": "Glue 1 - Gumblood Cauldron",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Glue1.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Glue1.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Glue1.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "experiencePoints": 1000,
        "rotDays": 0
    },
    {
        "_id": "55b03bc3d2de4a31",
        "name": "Clock 6 - Clock Facing Wheel",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "5cf9768a14e1ecd5",
        "name": "Spring 3 - Springypole",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Spring3.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Spring3.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Spring3.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "6b8a35033168fc77",
        "name": "Shaft 3 - Varnish Vat",
        "experiencePoints": 1000,
        "rotDays": 0,
        "level": null,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "b8a35033168fc775",
        "name": "Shaft 2 - Hollowing Fiddle",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "SZb2IdoH0zgnu2Sa",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ]
    },
    {
        "_id": "555b03bc3d2de4a3",
        "name": "Clock 5 - Escapement Levers",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "8a14e1ecd555b03b",
        "name": "Rubber 1 - Boiling vat",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "e1ecd555b03bc3d2",
        "name": "Rubber 5 - Pressurised Shrinking vat",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "8a35033168fc7754",
        "name": "Shaft 1 - Stretching Bath",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "e084d6f77147b48d",
        "name": "Coil String Furnace",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "26d94be084d6f771",
        "name": "Transistone Furnace",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "084d6f77147b48d9",
        "name": "Microtile Punch",
        "experiencePoints": 1000,
        "rotDays": null,
        "rotRate": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "6d94be084d6f7714",
        "name": "Ferropacitor Press",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "84d6f77147b48d94",
        "name": "Plumbpacitor Vat",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "7b26d94be084d6f7",
        "name": "Diode Loom",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "4d6f77147b48d947",
        "name": "Alloysteel Furnace",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "c4038d3d0050f833",
        "name": "Clothing - Primitive Tailors",
        "experiencePoints": 1000,
        "rotRate": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "4038d3d0050f8339",
        "name": "Clothing - Hide Tailors",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "z0lXotd7wdJR4sY2",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ]
    },
    {
        "_id": "f9768a14e1ecd555",
        "name": "Glue 2 - Pulling Machine",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "SZb2IdoH0zgnu2Sa",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Glue2.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Glue2.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Glue2.B2",
                "type": "WALL"
            }
        ]
    },
    {
        "_id": "8d3d0050f8339d2d",
        "name": "Clothing - Leather Tailors",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2"
    },
    {
        "_id": "050f8339d2ddb4e8",
        "name": "Clothing - Felt Weave Tailors",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2"
    },
    {
        "_id": "b26d94be084d6f77",
        "name": "Floe Turbine",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "rotDays": 0,
        "experiencePoints": 1000
    },
    {
        "_id": "0050f8339d2ddb4e",
        "name": "Clothing - Silk Fur Tailors",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "z0lXotd7wdJR4sY2",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ]
    },
    {
        "_id": "4be084d6f77147b4",
        "name": "Transformer File",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "50f8339d2ddb4e8b",
        "name": "Clothing - Rubber Weave Tailors",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2"
    },
    {
        "_id": "339d2ddb4e8bd12f",
        "name": "Armour 2 - Duosteel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "xvLTnQzjIhcEIufd",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ]
    },
    {
        "_id": "d0050f8339d2ddb4",
        "name": "Clothing - Fur Tailors",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2"
    },
    {
        "_id": "0f8339d2ddb4e8bd",
        "name": "Clothing - Wireskin Weave Tailors",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2"
    },
    {
        "_id": "d2ddb4e8bd12fc4d",
        "name": "Armour 5 - Pentasteel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "xvLTnQzjIhcEIufd"
    },
    {
        "_id": "9d2ddb4e8bd12fc4",
        "name": "Armour 4 - Quatristeel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "xvLTnQzjIhcEIufd"
    },
    {
        "_id": "be084d6f77147b48",
        "name": "Inductor Flux Boards",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "ddb4e8bd12fc4d9e",
        "name": "Armour 7 - Septasteel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "xvLTnQzjIhcEIufd"
    },
    {
        "_id": "39d2ddb4e8bd12fc",
        "name": "Armour 3 - Tristeel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "skillName": "xvLTnQzjIhcEIufd",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ]
    },
    {
        "_id": "d3d0050f8339d2dd",
        "name": "Clothing - Pluma Tailors",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2"
    },
    {
        "_id": "12fc4d9ee8548289",
        "name": "Pluma 3 - Ginning Bucket",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "3d0050f8339d2ddb",
        "name": "Clothing - Vetch Tailors",
        "experiencePoints": 1000,
        "rotRate": 0,
        "skillName": "z0lXotd7wdJR4sY2",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ]
    },
    {
        "_id": "2ddb4e8bd12fc4d9",
        "name": "Armour 6 - Hexasteel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "xvLTnQzjIhcEIufd"
    },
    {
        "_id": "bd12fc4d9ee85482",
        "name": "Pluma 1 - Fibre Crank",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "4e8bd12fc4d9ee85",
        "name": "Armour 10 - Decasteel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "xvLTnQzjIhcEIufd"
    },
    {
        "_id": "b4e8bd12fc4d9ee8",
        "name": "Armour 9 - Nonasteel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "xvLTnQzjIhcEIufd"
    },
    {
        "_id": "94be084d6f77147b",
        "name": "Oscillator Anvil",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Blacksmiths.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Blacksmiths.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "Blacksmiths.A3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Blacksmiths.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Blacksmiths.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "rotRate": null,
        "rotDays": 0,
        "experiencePoints": 1000
    },
    {
        "_id": "8339d2ddb4e8bd12",
        "name": "Armour 1 - Alloysteel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "xvLTnQzjIhcEIufd"
    },
    {
        "_id": "f8339d2ddb4e8bd1",
        "name": "Clothing - Tetra Weave Tailors",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2"
    },
    {
        "_id": "2fc4d9ee8548289f",
        "name": "Vetch 1 - Vetch Roller",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "fc4d9ee8548289f8",
        "name": "Vetch 2 - Stem Beater",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "9ee8548289f831ef",
        "name": "Fur 2 - Toxin Filter",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "db4e8bd12fc4d9ee",
        "name": "Armour 8 - Octosteel Armoury",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "xvLTnQzjIhcEIufd"
    },
    {
        "_id": "4d9ee8548289f831",
        "name": "Vetch 4 - Stitchers",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "e8bd12fc4d9ee854",
        "name": "Leather 1 - Guts Cleaner",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "ee8548289f831ef7",
        "name": "Fur 3 - Fume Vat",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "c4d9ee8548289f83",
        "name": "Vetch 3 - Soak Vat",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "d9ee8548289f831e",
        "name": "Fur 1 - Spine Shaker",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "8289f831ef7d3ebc",
        "name": "Silk Fur 4 - Silkbind Frame",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Silkfur4.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Silkfur4.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Silkfur4.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "31ef7d3ebc3b1c9e",
        "name": "Rubber Weave 2 - Stretch Rack",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "89f831ef7d3ebc3b",
        "name": "Felt Weave 2 - Grist Paddle",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "f831ef7d3ebc3b1c",
        "name": "Felt Weave 4 - Weave Plate",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "831ef7d3ebc3b1c9",
        "name": "Rubber Weave 1 - Sap Strainer",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "289f831ef7d3ebc3",
        "name": "Felt Weave 1 - Mat Press",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "1ef7d3ebc3b1c9e1",
        "name": "Rubber Weave 3 - Heat Drum",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "ef7d3ebc3b1c9e1d",
        "name": "Rubber Weave 4 - Bind Loom",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "d3ebc3b1c9e1db94",
        "name": "Wireskin Weave 3 - Pulse Oven",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "WireskinWeave3.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "WireskinWeave3.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "WireskinWeave3.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "48289f831ef7d3eb",
        "name": "Silk Fur 3 - Gloss Drum",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Silkfur3.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Silkfur3.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Silkfur3.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "548289f831ef7d3e",
        "name": "Silk Fur 2 - Acid Bath",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Silkfur2.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Silkfur2.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Silkfur2.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "3ebc3b1c9e1db943",
        "name": "Wireskin Weave 4 - Mesh Shaper",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "WireskinWeave4.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "WireskinWeave4.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "WireskinWeave4.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "f7d3ebc3b1c9e1db",
        "name": "Wireskin Weave 1 - Edge Cutter",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "WireskinWeave1.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "WireskinWeave1.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "WireskinWeave1.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "ebc3b1c9e1db9430",
        "name": "Tetra Weave 1 - Geode Cutter",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "7d3ebc3b1c9e1db9",
        "name": "Wireskin Weave 2 - Tensile Twister",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "WireskinWeave2.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "WireskinWeave2.B1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "WireskinWeave2.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "d12fc4d9ee854828",
        "name": "Pluma 2 - Lint Beater",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "3b1c9e1db9430a3b",
        "name": "Tetra Weave 4 - Stabilization Bath",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "09417bb4e8855ce1",
        "name": "Felt Weave 3 - Pasting Tubes",
        "experiencePoints": 1000,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "c3b1c9e1db9430a3",
        "name": "Tetra Weave 3 - Pattern Loom",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "bc3b1c9e1db9430a",
        "name": "Tetra Weave 2 - Spin Tumbler",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "8548289f831ef7d3",
        "name": "Silk Fur 1 - Thread Comb",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Silkfur1.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Silkfur1.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Silkfur1.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "334bd00c288728c4",
        "name": "Gossom Loom",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2"
    },
    {
        "_id": "e8548289f831ef7d",
        "name": "Fur 4 - Fur Binders",
        "experiencePoints": 1000,
        "rotDays": 0,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Carpenters.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Carpenters.A2",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Carpenters.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa"
    },
    {
        "_id": "3bb6e9471a6b2a5e",
        "name": "Pluma 4 - Pluma Loom",
        "experiencePoints": 1000,
        "rotDays": 300,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "level": 0
    },
    {
        "_id": "34bd00c288728c4a",
        "name": "Clothing - Gossom Tailors",
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Tailors.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "Tailors.A2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "EMPTY",
                "type": "DOOR"
            },
            {
                "x": 1,
                "y": 0,
                "tileKey": "Tailors.B3",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 1,
                "tileKey": "Tailors.C1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": 1,
                "tileKey": "Tailors.C2",
                "type": "WALL"
            },
            {
                "x": 1,
                "y": 1,
                "tileKey": "EMPTY",
                "type": "DOOR"
            }
        ],
        "skillName": "z0lXotd7wdJR4sY2",
        "rotDays": 0,
        "experiencePoints": 1000
    },
    {
        "_id": "398fa5ce057d28b9",
        "name": "Casing 4 - Casing Press",
        "experiencePoints": 1000,
        "boundries":
        [
            {
                "x": -1,
                "y": -1,
                "tileKey": "Casing4.A1",
                "type": "WALL"
            },
            {
                "x": 0,
                "y": -1,
                "tileKey": "EMPTY",
                "type": "WALL"
            },
            {
                "x": -1,
                "y": 0,
                "tileKey": "Casing4.B1",
                "type": "DOOR"
            },
            {
                "x": 0,
                "y": 0,
                "tileKey": "Casing4.B2",
                "type": "WALL"
            }
        ],
        "skillName": "SZb2IdoH0zgnu2Sa",
        "rotDays": 0
    }
];